"use client";

import { c as _c } from "react/compiler-runtime";
import { BotpressScripts } from "./botpress-scripts";
import { BigButtonTrigger, CTAButtonTrigger, FABTrigger, MoreMenuTrigger } from "./chat-triggers";
import { useBotpressWebchat } from "./use-botpress-webchat";
export interface BotpressChatProps {
  /**
   * Display mode for the chatbot
   * - 'fab': Floating action button (default)
   * - 'cta-button': Button for CTA bar
   * - 'big-button': Large dedicated button for contact page
   * - 'more-menu': Menu item format
   * - 'custom': Custom button triggering the chat
   * - 'hidden': Load scripts but don't show any UI (for testing)
   */
  mode?: "fab" | "cta-button" | "big-button" | "more-menu" | "custom" | "hidden";
  className?: string;
  children?: React.ReactNode;
  onToggle?: (isOpen: boolean) => void;
}

/**
 * Botpress Chat component with multiple display modes
 * Uses the Botpress embed scripts for webchat integration
 */
export function BotpressChat(t0) {
  const $ = _c(9);
  const {
    mode: t1,
    className: t2,
    children,
    onToggle
  } = t0;
  const mode = t1 === undefined ? "fab" : t1;
  const className = t2 === undefined ? "" : t2;
  const {
    isOpen
  } = useBotpressWebchat();
  let t3;
  if ($[0] !== children || $[1] !== className || $[2] !== isOpen || $[3] !== mode || $[4] !== onToggle) {
    const renderTrigger = () => {
      switch (mode) {
        case "fab":
          {
            return <FABTrigger isOpen={isOpen} className={className} />;
          }
        case "cta-button":
          {
            return <CTAButtonTrigger />;
          }
        case "more-menu":
          {
            return <MoreMenuTrigger />;
          }
        case "big-button":
          {
            return <BigButtonTrigger className={className} />;
          }
        case "custom":
          {
            return <button type="button" onClick={() => {
              onToggle?.(!isOpen);
            }} id="bp-toggle-chat" className={className}>{children}</button>;
          }
        case "hidden":
          {
            return <button type="button" id="bp-toggle-chat" className="hidden" style={{
              display: "none",
              visibility: "hidden",
              opacity: 0,
              pointerEvents: "none"
            }} aria-hidden="true" />;
          }
        default:
          {
            return null;
          }
      }
    };
    t3 = renderTrigger();
    $[0] = children;
    $[1] = className;
    $[2] = isOpen;
    $[3] = mode;
    $[4] = onToggle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BotpressScripts />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}